import _e from 'common/localeUtil';

export const BRANDING_TYPE = {
	TYPE_WEBSITE: 'WEB',
	TYPE_REPORT_COVER: 'RPC',
	TYPE_EBOOK_INTRO: 'EBIT'
};

export const MESSAGE_TYPES = {
	SUCCESS: 'success',
	FAIL: 'failed',
	LINKCOPIED: 'linkcopied'
};

export const REVISION_STATUSES = {
	PUBLISHED: 'P',
	DRAFT: 'D',
	BLANK: 'B'
};

export const DEFAULT_EBOOK_URL =
	'https://static.goalsmapper.com/public/platform/agent_website/ebook/goalsmapping_ebook_ni.pdf';

export const DEFAULT_TH_EBOOK_URL =
	'https://static.goalsmapper.com/public/platform/agent_website/ebook/goalsmapper_ebook_ni_th.pdf';

export const DEFAULT_FAVICON_URL =
	'https://static.goalsmapper.com/public/platform/goalsmapper/GM-Icon.png';

export const SHOWING_SECTION_CONTENT = true;
export const SHOWING_SECTION_CONTACT = false;
export const SHOWING_SECTION_STYLE = false;
export const SHOWING_SECTION_SEO = false;
export const SHOWING_SECTION_SETTINGS = false;
export const SHOWING_CUSTOMISETESTIMONIALSDIALOG = false;

export const ALL_WIDGETS = () => {
	return [
		{
			id: 'widget-edu',
			title: _e('education_calculator'),
			subtitle: _e('education_calculator_desc'),
			image: 'https://static.goalsmapper.com/public/platform/gmbrand/Education.svg',
			widgetUrlStage: `${process.env.REACT_APP_WIDGET_URL}/oversea-study`,
			widgetUrl: `${process.env.REACT_APP_WIDGET_URL}/oversea-study`
		},
		{
			id: 'widget-insurance',
			title: _e('insurance_calculator'),
			subtitle: _e('insurance_calculator_desc'),
			image: 'https://static.goalsmapper.com/public/platform/gmbrand/Insurance.svg',
			widgetUrlStage: `${process.env.REACT_APP_WIDGET_URL}/insurance-planner`,
			widgetUrl: `${process.env.REACT_APP_WIDGET_URL}/insurance-planner`
		},
		{
			id: 'widget-retirement',
			title: _e('retirement_calculator'),
			subtitle: _e('retirement_calculator_desc'),
			image: 'https://static.goalsmapper.com/public/platform/gmbrand/Retirement.svg',
			widgetUrlStage: `${process.env.REACT_APP_WIDGET_URL}/retirement-planner`,
			widgetUrl: `${process.env.REACT_APP_WIDGET_URL}/retirement-planner`
		}
		// {
		// 	id: 'widget-mortgage',
		// 	title: _e('mortgage_rates'),
		// 	subtitle: _e('mortgage_rates_desc'),
		// 	image: 'https://static.goalsmapper.com/public/platform/mortgage/mortgage1.png',
		// 	widgetUrlStage: `${process.env.REACT_APP_WIDGET_URL}/mortgage-planner`,
		// 	widgetUrl: `${process.env.REACT_APP_WIDGET_URL}/mortgage-planner`
		// },
		// {
		// 	id: 'widget-medical-concierge',
		// 	title: _e('medical_concierge'),
		// 	subtitle: _e('medical_concierge_desc'),
		// 	image:
		// 		'https://static.goalsmapper.com/public/platform/empty_state/medical_concierge_visual_with_partner.svg',
		// 	widgetUrlStage: `${process.env.REACT_APP_WIDGET_URL}/medical-concierge`,
		// 	widgetUrl: `${process.env.REACT_APP_WIDGET_URL}/medical-concierge`
		// }
	];
};

export const CONTACT_DISCLAIMER_DEFAULT = () => {
	return [
		{
			type: 'paragraph',
			children: [
				{
					text: _e('content_form_disclaimer_desc')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: ''
				}
			]
		},
		{
			type: 'bulleted-list',
			children: [
				{
					type: 'list-item',
					children: [
						{
							text: _e('perform_holistic_review')
						}
					]
				},
				{
					type: 'list-item',
					children: [
						{
							text: _e('send_marketing_information')
						}
					]
				},
				{
					type: 'list-item',
					children: [
						{
							text: _e('comply_laws')
						}
					]
				},
				{
					type: 'list-item',
					children: [
						{
							text: _e('notify_promotions')
						}
					]
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: ''
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('contact_information_submit_message')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: ''
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('proceed_if_agree_contact')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: ''
				}
			]
		}
	];
};

export const WIDGET_DISCLAIMER_DEFAULT = () => {
	return [
		{
			type: 'paragraph',
			children: [
				{
					text: _e('consent_personal_data_collection')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('consent_personal_data_collection_1')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('consent_personal_data_collection_2')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('consent_personal_data_collection_3')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('consent_personal_data_collection_4')
				}
			]
		},
		{
			type: 'paragraph',
			children: [
				{
					text: _e('proceed_if_agree_contact')
				}
			]
		}
	];
};
